import CustomHelmet from '../CustomHelmet';
import { BASE_TITLE } from '../Common';
import { Grid,Box } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@mui/styles';
import AppTools from '../ListGroups/AppTools';

const useStyles = makeStyles({
    ToolImg: {
        width: "auto",
        height: "auto",
        maxWidth: "75px",
        maxHeight: "75px",
        margin:"0.5rem"
    },
    UseBox:{
        borderRadius:"8px",
        padding:"1.25rem",
        margin:"1rem",
        width:"100%",
        border:"1px solid #E9EBED",
    }
})

const DetailLook = () => {
    const classes = useStyles();

    return (
        <>
            <CustomHelmet title={BASE_TITLE + "首頁"} />
            <FormControl component="article" fullWidth>
                <Grid container>
                    <Grid item style={{ marginLeft: "auto", marginRight: "auto" }} lg={9}>
                        <Box style={{width:"100%"}}>
                            <h2 className="main-header">
                                專案管理/軟體開發的管理工具
                            </h2>
                            <Grid container>
                                {
                                    AppTools.tools.map((el,index)=>{
                                        return (<Box sx={{ display: "flex", alignItems: "center",margin:"0.5rem",padding:"0.5rem" }} className="shape-line" key={index}>
                                            <img src={el.src} className={classes.ToolImg} alt={el.text}/>
                                            <span style={{fontSize:"22px"}}>{el.text}</span>
                                            </Box>)
                                    })
                                }
                            </Grid>
                        </Box>
                        <Box style={{width:"100%"}}>
                            <h2 className="main-header">
                                我們是如何進行軟體開發
                            </h2>
                            <Grid container>
                                {
                                    AppTools.howToUse.map((el,index)=>{
                                        return (<Box sx={{ backgroundColor:el.backgroundColor }} key={index} className={classes.UseBox}>
                                                <h3 style={{fontWeight:"bold",fontSize:"30px"}}>{el.headerText}</h3>
                                                <p style={{fontSize:"22px",whiteSpace:"pre-line"}}>{el.bodyText}</p>
                                            </Box>)
                                    })
                                }
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </FormControl>
        </>
    );

}

export default DetailLook;